<template>
  <div>
    <a-row>
      <a-tabs defaultActiveKey="1">
        <a-tab-pane tab="CONCEPTOS" key="1">
          <g-master name="coc"
                    :endpoint="CocMaster.endpoint"
                    :tableSetup="CocMaster.tableSetup"
                    :modalFieldsSetup="CocMaster.modalFieldsSetup"
                    modalWidth="80%"
                    @params="paramsTable"
          >
            <template slot="customButton">
              <g-btn-excel :endpoint="endpointExcel" :params="paramsExcel" :fileName="fileNameExcel"/>
            </template>
            <template slot="masterModal" slot-scope="{record}">
              <a-row :gutter="[16,16]">
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" label="ID Concepto: ">
                    <a-input
                      v-decorator="['id_coc', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
                  </a-form-item>
                </a-col>

                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" label="Nombre: ">
                    <a-input
                      v-decorator="['coc_name', { rules: [{ required: false}] }]"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" label="Nombre corto: ">
                    <a-input
                      v-decorator="['coc_short_name', { rules: [{ required: false}] }]"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <g-dropdown endpoint="hierarchy_lookup"
                              label="Naturaleza: "
                              :formItemConfig="fiOptions"
                              :decorator="['coc_natu', { rules: [{ required: false, message: 'Valor requerido' }] }]"
                              :params="id_h_param_type">
                  </g-dropdown>

                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" label="Prioridad: ">
                    <a-input
                      v-decorator="['coc_priority', { rules: [{ required: false}] }]"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <g-dropdown endpoint="hierarchy_lookup"
                              label="Coc full: "
                              :formItemConfig="fiOptions"
                              :decorator="['coc_full', { rules: [{ required: false, message: 'Valor requerido' }] }]"
                              :params="full">
                  </g-dropdown>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" label="Medida: ">
                    <a-input
                      v-decorator="['coc_unit_measure', { rules: [{ required: false}] }]"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" label="Estado" :has-feedback="false">
                    <a-checkbox v-decorator="['status', {valuePropName: 'checked'}]">
                    </a-checkbox>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" label="Factor: ">
                    <a-input
                      v-decorator="['coc_factor', { rules: [{ required: false}] }]"/>
                  </a-form-item>
                </a-col>
              </a-row>
            </template>
          </g-master>
          <a-tabs v-if="!idCoc" defaultActiveKey="1">
            <a-tab-pane tab="Procesos" key="1">
              <span>Seleccione un concepto para ver más.</span>
            </a-tab-pane>
            <a-tab-pane tab="Asignación de grupos" key="2">
              <span>Seleccione un concepto para ver más.</span>
            </a-tab-pane>
          </a-tabs>
          <asigyproc v-if="idCoc" :id_coc="idCoc"></asigyproc>
        </a-tab-pane>

        <a-tab-pane tab="GRUPOS" key="2">
          <tabgrupos/>
        </a-tab-pane>
      </a-tabs>
    </a-row>
  </div>
</template>
<script>
  export default {
    data () {
      return {
        paramsT: {},
        endpointExcel: 'coc_/downloadExcel',
        fileNameExcel: 'Conceptos',
        id_h_param_type: {
          h_lookup_type: 'NATURALEZA',
          use_code: true
        },
        full: {
          h_lookup_type: 'ESTADO_SN',
          use_code: true
        },
        colOptions: {xs: 24, sm: 12},
        fiOptions: {
          'label-col': {span: 8},
          'wrapper-col': {span: 16},
          'has-feedback': true
        },
        CocMaster: {
          endpoint: 'coc',
          tableSetup: {
            allowSelect: true,
            selectedRows: [],
            tableConfig: {
              rowKey: 'id_coc'
            },
            columns: [
              {title: '#', dataIndex: 'id_coc', sorter: true},
              {title: 'Nombre', dataIndex: 'coc_name', sorter: true},
              {title: 'Nombre corto', dataIndex: 'coc_short_name', sorter: true},
              {title: 'Naturaleza', dataIndex: 'coc_natu', sorter: true},
              {title: 'Prioridad', dataIndex: 'coc_priority', sorter: true},
              {title: 'Full', dataIndex: 'coc_full', sorter: true},
              {title: 'Medida', dataIndex: 'coc_unit_measure', sorter: true},
              {title: 'Factor', dataIndex: 'coc_factor', sorter: true},
              {title: 'Estado', dataIndex: 'estado', sorter: true},
              {title: 'Creado por', dataIndex: 'created_by', sorter: true},
              {title: 'Creado el', dataIndex: 'created_on', sorter: true},
              {title: 'Modificado por', dataIndex: 'modified_by', sorter: true},
              {title: 'Modificado el', dataIndex: 'modified_on', sorter: true}
            ]
          },
          modalFieldsSetup: [
            {name: 'id_coc'},
            {name: 'coc_name'},
            {name: 'coc_short_name'},
            {name: 'coc_natu'},
            {name: 'coc_priority'},
            {name: 'coc_full'},
            {name: 'coc_unit_measure'},
            {name: 'coc_factor'},
            {name: 'status'}
          ]
        }
      }
    },
    methods: {
      paramsTable (params) {
        this.paramsT = params
      }
    },
    computed: {
      idCoc () {
        return this.CocMaster.tableSetup.selectedRows.length > 0 ? this.CocMaster.tableSetup.selectedRows[0].id_coc : null
      },
      paramsExcel () {
        return {
          ...this.paramsT,
          columns: this.CocMaster.tableSetup.columns
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Mantenimiento/Coc/Coc.vue